/* tslint:disable */
import * as React from 'react';
import {Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm, submit} from 'redux-form';
import {difference, find, flow, forEach, get, isEmpty, map, size} from 'lodash';
import {II18nMessages} from '../../../../services/branding/models';
import {Button, Col, ControlLabel, Form, FormGroup, Modal, Row} from 'react-bootstrap';
import FieldFormControl from '../../../../components/FieldFormControl';
import RegionSelect from './components/RegionSelect/RegionSelect';
import RegionSelected from './components/RegionSelect/RegionSelected';
import CruiseQuestion from './components/CruiseQuestion/CruiseQuestion';
import {connect} from 'react-redux';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker/index';
import {
  IChannel,
  IDestination,
  IIndustry,
  IOccupation,
  IPolicyApplication,
  IProduct,
  ITraveller,
  TripType,
} from '../../../../data/api/models';
import {
  annualLimit,
  isAfter,
  isBefore,
  isFutureDate,
  isNotFalse,
  isRequired,
  isValidDate,
  singleLimit,
  singleMaxTripDuration,
} from '../../../../util/validators';
import * as moment from 'moment';
import {isAnnual, showDestinationDuration, showDestinations} from '../../../../data/api/api';
import {actions as quoteActions, getInitValues} from '../../../../services/quote/reducer';
import {IAuthState} from '../../../../services/auth/models';
import {bindActionCreators} from 'redux';
import {IQuoteActions} from '../../../../services/quote/models';
import Travellers from './components/Travellers';
import FaChevronRight from 'react-icons/fa/chevron-right';
import VoucherCode from '../../components/VoucherCode';
import MarketingOptions from '../../components/MarketingOptions';
import {IStore} from '../../../../redux/IStore';
import GroupType from './components/GroupType/GroupType';
import GroupTypeSelected from './components/GroupType/GroupTypeSelected';
import MaxTripDuration from './components/MaxTripDuration/MaxTripDuration';
import ActivitiesSelect from './components/ActivitiesSelect/ActivitiesSelect';
import CovidStatement from './components/CovidStatement';
import SelectControl from '../../../../components/SelectControl';

interface ITripDetailsFormProps extends InjectedFormProps {
  destinations: IDestination[];
  occupations: IOccupation[];
  industries: IIndustry[];
  auth: IAuthState;
  i18n: II18nMessages;
  travellers: ITraveller[];
  groupType: string;
  cruiseCover: boolean;
  tripType: TripType;
  startDate: string;
  region: string;
  maxTripDuration: string;
  schemeId: string;
  endDate: string;
  dispatch: any;
  product: IProduct;
  destinationsValue: string[];
  occupationValue: string[];
  industryValue: string[];
  channel: IChannel;
  quote: IPolicyApplication;

  renderDefinition(name: string): any;

  actions: {
    quote: IQuoteActions;
    submit(name: string);
  };

  campaignCode ?: string;
}

interface ITripDetailsStates {
  showBlockerModal: boolean;
  modalMessage: string;
  region: string;
  activities: string[];
  activitiesValid: boolean;
  backToIndividual: boolean;
}

class TripDetailsForm extends React.Component<ITripDetailsFormProps, ITripDetailsStates> {
  public state = {
    showBlockerModal: false,
    modalMessage: '',
    region: '',
    activities: [],
    activitiesValid: true,
    backToIndividual: false,
  };

  public componentWillMount() {
    const {product, change, initialValues, dispatch, channel, auth, campaignCode} = this.props;

    const data = getInitValues(product, null, null);

    forEach(data, (value, key) => {
      if (initialValues[key] === null) {
        change(key, value);
      }
    });

    const dateFromApi = (date) => {
      if (!date) {
        return '';
      }

      const parsedDate = moment(date).format('DD/MM/YYYY');

      return parsedDate !== 'Invalid Date' ? parsedDate : '';
    };

    dispatch(change('salesChannel', channel.key));
    dispatch(change('quotationTypes', 'Direct'));

    if (campaignCode) {
      dispatch(change('campaignCode', campaignCode));
    }
    // dispatch(change('emailSend', false));

    // Set the trip type field automatically as there is only one for this product.
    if (size(product.metadata.trip_type) > 0) {
      map(product.metadata.trip_type, (name, key: string) => {
        if (['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
                .includes(channel.key)
            && key === 'annual') {
          dispatch(change('tripType', key));
        }
      });
    }

    // Set the destination field automatically as there is only one for this product.
    if (['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
        .includes(channel.key)) {
      dispatch(change('region', 'worldwide'));
    }

    if (auth.isAuthenticated) {
      dispatch(change('travellers[0].title', auth.customer.title));
      dispatch(change('travellers[0].dob', dateFromApi(auth.customer.dob)));
      dispatch(change('travellers[0].firstName', auth.customer.firstName));
      dispatch(change('travellers[0].lastName', auth.customer.lastName));
      dispatch(change('travellers[0].email', auth.customer.email));
      dispatch(change('travellers[0].phone', auth.customer.phone1));
      dispatch(change('travellers[0].address.postcode', auth.customer.address.postcode));
      dispatch(change('travellers[0].address.line1', auth.customer.address.line1));
      dispatch(change('travellers[0].address.line2', auth.customer.address.line2));
      dispatch(change('travellers[0].address.town', auth.customer.address.town));
      dispatch(change('travellers[0].address.country', auth.customer.address.country));
    }
  }

  public componentDidUpdate() {
    const {tripType, dispatch, change, product, channel} = this.props;
    const regionTripType = tripType;

    if (regionTripType === 'single') {
      // dispatch(change('region', ''));
      dispatch(change('maxTripDuration', ''));
    }

    if (regionTripType === 'annual') {
      dispatch(change('destinations', ''));
      if (!['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
          .includes(channel.key)) {
        dispatch(change('endDate', ''));
      }
      if (size(product.metadata.annual_trip_durations) === 1) {
        dispatch(change('maxTripDuration', Object.keys(product.metadata.annual_trip_durations)[0]));
      }
      if (['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c']
          .includes(channel.key)) {
        dispatch(change('endDate', this.getExpiryDate()));
      }
    }
  }

  private getExpiryDate = () => {
    // TODO: Refactor this function
    const { channel } = this.props;
    const dateFormat = 'DD/MM/YYYY';
    const currentDate = moment();

    if (channel.key === 'fps-b2c') {
      const expiryDate = moment()
          .month(9)
          .date(31)
          .startOf('day');

      if (currentDate.isSameOrAfter(expiryDate)) {
        expiryDate.add(1, 'year');
      }

      return expiryDate.format(dateFormat);
    }

    if (['npo-b2c', 'npor-b2c'].includes(channel.key)) {
      const expiryDate = moment()
          .month(4)
          .date(31)
          .startOf('day');

      if (currentDate.isSameOrAfter(expiryDate)) {
        expiryDate.add(1, 'year');
      }

      return expiryDate.format(dateFormat);
    }

    if (['cspa-b2c', 'cspar-b2c'].includes(channel.key)) {
      const expiryDate = moment()
          .month(5)
          .date(30)
          .startOf('day');

      if (currentDate.isSameOrAfter(expiryDate)) {
        expiryDate.add(1, 'year');
      }

      return expiryDate.format(dateFormat);
    }

    if (channel.key === 'css-b2c') {
      const expiryDate = moment()
          .month(8)
          .date(30)
          .startOf('day');

      if (currentDate.isSameOrAfter(expiryDate)) {
        expiryDate.add(1, 'year');
      }

      return expiryDate.format(dateFormat);
    }
  }

  private getAge = (dob) => {

    if (isEmpty(dob)) {
      return null;
    }

    const convertedDate = dob.split(/\//).reverse().join('/');
    return moment().diff(convertedDate, 'years');
  }

  public componentWillReceiveProps(nextProps) {
    const {tripType, dispatch, change, actions, schemeId} = this.props;

    if (schemeId && tripType !== nextProps.tripType) {
      dispatch(change('schemeId', ''));
      actions.quote.calculate(null, true);
    }
  }

  public renderAboutUs = () => {
    const {channel} = this.props;

    const TERMS_OF_BUSINESS = 'Terms of Business';
    const aiosDocument = find(channel.productDocuments, (document) => {
      return document.shortName === TERMS_OF_BUSINESS;
    });
    const aboutUsUrl = aiosDocument ? aiosDocument.filePath : '';

    return (
        <div className="margin-top margin-bottom">
          For more information about our service to you and how we will use your information,
          please read our <a href={aboutUsUrl} target="_blank"><strong>Terms of Business</strong> </a>
          and our <a href={get(channel, channel.key === 'npo-b2c' ? 'urls.privacy' : 'urls.privacyCookies', '')} target="_blank">
          <strong>Privacy Policy</strong></a>.
        </div>
    );
  }

  private checkForErrorBeforeSubmit = () => {
    const {tripType, startDate, endDate, travellers, actions, product, maxTripDuration, channel} = this.props;
    const start = moment(startDate, 'DD/MM/YYYY');
    const end = moment(endDate, 'DD/MM/YYYY');
    const tripDuration = tripType === 'single' ? end.diff(start, 'days') : maxTripDuration;

    const validationRules = {
      FST: {
        single: [
          {maxTrip: 90, maxAge: 79},
        ],
        annual: [],
      },
      DIA: {
        single: [
          {maxTrip: 90, maxAge: 79},
        ],
        annual: [
          {productCode: 'DIA', maxAge: 79},
        ],
      },
    };

    const validationMessages = {
      DIA: 'Sorry, Diabetes is unable to provide a quote due to your age.',
    };

    let message;
    const rules = validationRules[product.productCode] && validationRules[product.productCode][tripType] || [];
    const valid = travellers.reduce((carry, traveller) => {
      const travellerAge = this.getAge(traveller.dob);
      return carry && rules.reduce((carry, rule) => {
        if (rule.maxAge) {
          if (travellerAge > rule.maxAge) {
            carry =  rule.maxTrip ? carry && tripDuration <= rule.maxTrip :  carry && travellerAge <= rule.maxAge;
          }
          return carry;
        }
      }, true);
    }, true);
    message = validationMessages[product.productCode] || 'Sorry, ' + channel.name +
        ' is unable to provide a quote online due to your planned trip duration.';

    if (!valid) {
      this.setState({
        showBlockerModal: true,
        modalMessage: message,
      });
    } else {
      actions.submit('quote');
    }
  }

  private closeBlockerModal = () => {
    this.setState({
      showBlockerModal: false,
    });
  }

  private renderBlockerModal = () => {
    const {channel} = this.props;
    const {modalMessage} = this.state;

    return (
        <Modal show={this.state.showBlockerModal} onHide={this.closeBlockerModal}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Attention required</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ul>
              <li>
                <p>
                  {modalMessage}
                </p>
                <p>
                  Please call our specialist UK-based customer services team
                  on <strong>{channel.phone}</strong> to see if we can provide you with a quote.
                </p>
                <p>
                  We are open {channel.openingHours} closed Bank Holidays.
                </p>
              </li>
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button
                bsStyle="primary"
                onClick={this.closeBlockerModal}
            >
              CLOSE
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }

  private handleRegion = (value: any) => {
    const { dispatch, change } = this.props;
    dispatch(change('region', value.target.value));
    this.setState({
      region: value.target.value,
    });
  }

  private onSelectActivity = (value: any) => {
    const { change, dispatch } = this.props;

    this.setState({
      activitiesValid: true,
    });

    if (value.length === 0) {
      this.setState({
        activitiesValid: false,
      });
    }

    dispatch(change(`activities`, value));
  }

  private onSelectGroupType = (value: any) => {
    if ('individual' === value.target.value) {
      this.setState({
        backToIndividual: true,
      });
    }
  }

  public render() {
    const {
      i18n,
      submitting,
      tripType,
      handleSubmit,
      valid,
      startDate,
      product,
      renderDefinition,
      submitFailed,
      groupType,
      change,
      channel,
    } = this.props;

    const { activitiesValid } = this.state;
    const hasAdditionalOption = size(product.metadata[`group_type_trip_${tripType}`]) > 4;
    const maxTripDurationList = map(product.metadata.annual_trip_durations, (name, key) => ({
      label: name,
      value: key,
    }));

    const maxTripDefinition = product.metadata.definitions.max_trip_duration;
    const showMaxTripSelect = size(maxTripDurationList) > 1;
    const showCruiseCover = ['fst-b2c', 'tam-b2c'].includes(channel.key);
    let advancedTime = 90;
    const timeType = 'day';
    const annualTime = '366';
    let startDateMax = isAnnual(tripType) ? moment().add(annualTime, timeType) : moment().add(advancedTime, timeType);

    const maxDateSingle = () => {
      if (['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'css-b2c', 'cssr-b2c', 'cspa-b2c', 'cspar-b2c']
          .includes(channel.key)) {
        return moment(startDate, 'DD/MM/YYYY').add('185', 'day');
      }
      return moment(startDate, 'DD/MM/YYYY').add('93', 'day');
    };

    const isMariners = channel.key === 'mpt-b2c';
    const tripDurations = {
      FST: 94,
      CPS: 31,
      DIA: 94,
      MPT: 94,
      LSB: 549,
    };

    const currentDate = moment();

    const channelStartConfigs = {
      'fps-b2c': '-11-01',
      'fpr-b2c': '-11-01',
      'npo-b2c': '-06-01',
      'npor-b2c': '-06-01',
      'cspa-b2c': '-07-01',
      'cspar-b2c': '-07-01',
      'css-b2c': '-10-01',
      'cssr-b2c': '-10-01',
    };

    const channelEndConfigs = {
      'fps-b2c': '-10-31',
      'fpr-b2c': '-10-31',
      'npo-b2c': '-05-31',
      'npor-b2c': '-05-31',
      'cspa-b2c': '-06-30',
      'cspar-b2c': '-06-30',
      'css-b2c': '-09-30',
      'cssr-b2c': '-09-30',
    };

    const isEligibleChannel = Object.keys(channelStartConfigs).includes(channel.key) && tripType === 'annual';

    let startMonthAndDay = '';
    advancedTime = 31;
    let startDateToUse, currentCycleEndDate;
    let singleLimitValue = advancedTime;

    if (isEligibleChannel) {
      startMonthAndDay = channelStartConfigs[channel.key];

      const now = moment();

      startDateMax = now.clone().add(advancedTime, 'days');

      //Dynamically set maximum start date if in current cycle (year)
      const endDate = channelEndConfigs[channel.key];
      if(now.clone() < moment(`${now.year() + endDate}`)
          && startDateMax.isAfter(moment(`${now.year() + endDate}`))) {
        startDateMax = moment(`${now.year() + endDate}`);
        singleLimitValue = startDateMax.diff(now, 'days') + 1;
      }

      startDateToUse = moment(now.year() + startMonthAndDay);
      currentCycleEndDate = startDateToUse.clone().subtract(1, 'day');
    }

    const calendarStartDate = moment();
    let start = moment();

    if (currentDate >= currentCycleEndDate) {
      start = moment(currentDate.year() + startMonthAndDay);
    } else {
      start = moment(currentDate.year() + startMonthAndDay).subtract(1, 'year');
    }

    const nextStartDateAsText = start.clone().add(1, 'year').format('Do MMMM YYYY');
    const nextFormattedStartDate = start.clone().add(1, 'year').format('DD/MM/YYYY')

    const covidMessage = get(product.metadata, 'covid_message.travel_detail_b2c', '');

    const vehicleAge = [
      {label: '00', value: '00'},
      {label: '01', value: '01'},
      {label: '02', value: '02'},
      {label: '03', value: '03'},
      {label: '04', value: '04'},
      {label: '05', value: '05'},
      {label: '06', value: '06'},
      {label: '07', value: '07'},
      {label: '08', value: '08'},
      {label: '09', value: '09'},
      {label: '10', value: '10'},
      {label: '11', value: '11'},
      {label: '12', value: '12'},
      {label: '13', value: '13'},
      {label: '14', value: '14'},
      {label: '15', value: '15'},
    ];

    const filteredTravellers = () => {
      const productMetadata = product.metadata[`group_type_trip_${tripType}`];
      if (!productMetadata) {
        return null;
      }

      const order = ["individual", "couple", "family", "single_parent_family", "independent_child"];

      return Object.entries(productMetadata)
          .sort(([keyA], [keyB]) => order.indexOf(keyA) - order.indexOf(keyB))
          .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
          }, {} as Record<string, any>);
    };

    const REGION_ELIGIBLE = new Set([
      'fps-b2c', 'fpr-b2c',
      'npo-b2c', 'npor-b2c',
      'cspa-b2c', 'cspar-b2c',
      'css-b2c', 'cssr-b2c',
    ]);

    const CANONICAL_CHANNEL = {
      'fpr-b2c': 'fps-b2c',
      'npor-b2c': 'npo-b2c',
      'cspar-b2c': 'cspa-b2c',
      'cssr-b2c': 'css-b2c',
    };

    const isFps = (CANONICAL_CHANNEL[channel.key] || channel.key) === 'fps-b2c';

    return (
        <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
          <div className="steps-container">
            <div className="section-title">
              <h3>Your Details</h3>
            </div>
            <CovidStatement covidMessage={covidMessage}/>
            <div className="section">
              <FormGroup controlId="region">
                <Row>
                  <Col sm={3}>
                    <ControlLabel>
                      <div className="region-non-break-label">
                        Destinations / Policy Type Cover Type:
                        {renderDefinition('destinations')}
                      </div>
                    </ControlLabel>
                  </Col>
                  <Col sm={hasAdditionalOption ? 12 : 9}>
                    <Row className="destination-radio">
                      {map(product.metadata.regions, (name, key) => {
                        const region = (name as string).replace('Caribbean', '\nCaribbean\n');
                        return (
                            <Col xs={12} sm={6} md={hasAdditionalOption ? 2 : 3} key={key}>
                              <Field
                                  name="region"
                                  type="radio"
                                  value={String(key)}
                                  component={FieldFormControl}
                                  validate={[isRequired]}
                                  onValueChange={this.handleRegion}
                              >
                                <div>
                                  <RegionSelect channel={channel.key} name={String(key)} value={this.state.region}/>
                                  <RegionSelected name={String(key)} />
                                </div>
                                {region.replace('United Kingdom', 'UK')}
                              </Field>
                            </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col sm={12}>
                    {(channel.key === 'dia-b2c') && (
                        <ControlLabel style={{color: '#c22116'}}>
                          Following the outbreak of coronavirus (COVID-19), there will be no cover for cancellation,
                          abandonment, or curtailment claims if the Foreign, Commonwealth and Development Office (FCDO)
                          advises you not to travel, for example where the FCDO advise against all but essential travel to
                          an area affected by Coronavirus, COVID-19, Severe Acute Respiratory Syndrome (SARS-COV-2) or any
                          mutation of Coronavirus, COVID-19 or SARs-COV-2.
                        </ControlLabel>
                    )}
                  </Col>
                </Row>
              </FormGroup>
              {showMaxTripSelect && showDestinationDuration(tripType) && (
                  <FormGroup controlId="maxTripDuration">
                    <MaxTripDuration
                        i18n={i18n}
                        options={maxTripDurationList}
                        definition={maxTripDefinition}
                        renderDefinition={renderDefinition}
                    />
                  </FormGroup>
              )}
            </div>
            {showCruiseCover && (
                <div className="section section--no-padding">
                  <CruiseQuestion i18n={i18n} channel={channel}/>
                </div>
            )}
            <div className="section">
              <FormGroup controlId="group-type">
                <Row>
                  <Col sm={3}>
                    <ControlLabel>
                      <div className="non-break-label">
                        Travellers Details:{renderDefinition('group_type')}
                      </div>
                    </ControlLabel>
                  </Col>
                  <Col sm={hasAdditionalOption ? 12 : 9}>
                    <Row className="group-type-radio">
                      {map(filteredTravellers(), (name, key) => {
                        return (
                            <Col xs={6} sm={6} md={hasAdditionalOption ? 2 : 3} key={key}>
                              <Field
                                  name="groupType"
                                  type="radio"
                                  value={key}
                                  component={FieldFormControl}
                                  validate={[isRequired]}
                                  onChange={this.onSelectGroupType}
                              >
                                <div>
                                  <GroupType channel={channel} name={String(key)} />
                                  <GroupTypeSelected channel={channel} name={String(key)} />
                                </div>
                                {name}
                              </Field>
                            </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </FormGroup>
            </div>
            <div className="section">
              {!['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'css-b2c', 'cssr-b2c', 'cspa-b2c', 'cspar-b2c']
                  .includes(channel.key) && (
                  <FormGroup controlId="start-date">
                    <div className="internal-title">Travel Dates</div>
                    <br />
                  </FormGroup>
              )}
              <FormGroup controlId="start-date" style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'row'}}>
                <div style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', width: '70%'}}>
                  <div style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'row', width: '70%', marginBottom: '10px'}}>
                    <div style={{width: '30%'}}>
                      *Start date:
                      {showDestinations(tripType) ? renderDefinition('travel_dates_single_start_date') :
                          renderDefinition('travel_dates_annual')}
                    </div>
                    <div style={{width: '70%'}}>
                      <div className="alternative-date-picker">
                        <div className="field">
                          <Field
                              name="startDate"
                              type="masked-date"
                              placeholder="dd/mm/yyyy"
                              component={FieldFormControl}
                              validate={[annualLimit(advancedTime), isAfter(calendarStartDate), isBefore(startDateMax), singleLimit(singleLimitValue)]}
                          />
                        </div>
                        <div className="icon">
                          <Field
                              name="startDate"
                              minDate={calendarStartDate}
                              maxDate={startDateMax}
                              component={AlternativeDatePicker}
                              validate={[
                                annualLimit(advancedTime),
                                isAfter(calendarStartDate),
                                isBefore(startDateMax),
                                singleLimit(singleLimitValue),
                              ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    flexDirection: 'row',
                    width: '70%',
                    marginBottom: '10px'
                  }}>
                    <div style={{width: '30%'}}>
                      End date:
                    </div>
                    <div style={{width: '70%'}}>
                      <div className="alternative-date-picker">
                        <div className="field">
                          <Field
                              name="endDate"
                              type="masked-date"
                              component={FieldFormControl}
                              value={currentCycleEndDate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', width: '30%'}}>
                  {REGION_ELIGIBLE.has(channel.key) && (
                      <div style={{ width: '100%', textAlign: 'center' }}>
                        <div className="icon text-center">
                          <RegionSelect
                              channel={CANONICAL_CHANNEL[channel.key] || channel.key}
                              name="renewal"
                              value={this.state.region}
                          />
                        </div>
                      </div>
                  )}
                  {REGION_ELIGIBLE.has(channel.key) && (
                      <div style={{ width: '100%', marginTop: 15, textAlign: 'center' }}>
                        <div>
                          <span>Common Scheme Renewal Date</span><br />
                          <span>({nextFormattedStartDate})</span>
                        </div>
                      </div>
                  )}
                </div>
              </FormGroup>
              {tripType === 'annual' && ['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c'].includes(channel.key) && (
                  <Row className="important">
                  <span style={{ color: '#014990', fontWeight: 600 }}>* Please note: This is a membership scheme with a
                    common start date and renewal date. The scheme renewal
                    date for all policies issued under this scheme is {nextStartDateAsText}.</span> <br/>
                    When selecting a specific <span style={{ color: '#014990', fontWeight: 600 }}> ‘Start Date’ </span>
                    cover will run from that date to the next scheme renewal date. For example, if the Start Date is noted
                    as 1st December, then cover will run from this date until the scheme renewal date of {nextStartDateAsText}.<br/>
                    The reason for this is the insurance is provided solely as a Member Scheme and therefore, has joining
                    dates. This means cover is fixed, in any one insurance period, for all members. {isFps
                      ? 'Members enjoy the same level of policy benefit and cover irrespective of individual medical circumstance.'
                      : 'Members enjoy the same level of policy benefit, price and cover irrespective of age and individual medical circumstance.'}<br/>
                    Please note;<br/>
                    - No cover can be backdated<br/>
                    - No cover period can be greater than twelve months<br/>
                  </Row>
              )}
              {tripType === 'single' && (
                  <FormGroup controlId="end-date">
                    <Row>
                      <Col componentClass={ControlLabel} sm={3}>
                        Return date: {renderDefinition('travel_dates_single_end_date')}
                      </Col>
                      <Col sm={6}>
                        <div className="alternative-date-picker">
                          <div className="field">
                            <Field
                                name="endDate"
                                type="masked-date"
                                placeholder="dd/mm/yyyy"
                                component={FieldFormControl}
                            />
                          </div>
                          <div className="icon">
                            <Field
                                name="endDate"
                                minDate={startDate ? moment(startDate, 'DD/MM/YYYY') : moment()}
                                maxDate={startDate ? maxDateSingle() : moment()}
                                component={AlternativeDatePicker}
                                validate={isMariners ? [
                                      isRequired,
                                      isFutureDate,
                                      isValidDate,
                                    ] :
                                    [
                                      isRequired,
                                      isFutureDate,
                                      isValidDate,
                                      // minTripDuration(startDate),
                                      singleMaxTripDuration(startDate, tripDurations[product.productCode] || 365),
                                    ]
                                }
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </FormGroup>
              )}
            </div>
            <FieldArray
                name="travellers"
                i18n={i18n}
                product={product}
                component={Travellers}
                groupType={groupType}
                renderDefinition={renderDefinition}
                change={change}
                backToIndividual={this.state.backToIndividual}
            />
            { ['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c'].includes(channel.key) && (
                <div className="section">
                  <Row style={{marginBottom: '10px', marginTop: '-5px'}}>
                    <div style={{marginBottom: '20px' }}>
                        If you are unsure whether you have a valid membership, please check this with the association before purchasing a policy.
                    </div>
                    <Col sm={3} style={{paddingLeft: 0}}>
                      <ControlLabel>
                        Membership number:
                      </ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <Field
                          name="membershipNumber"
                          type="text"
                          placeholder={'Enter your membership number'}
                          component={FieldFormControl}
                      />
                    </Col>
                  </Row>
                </div>
            )}
            {!['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'css-b2c', 'cssr-b2c', 'cspa-b2c', 'cspar-b2c']
                .includes(channel.key) && (
                <div>
                  <VoucherCode
                      renderDefinition={renderDefinition}
                      {...this.props}
                  />
                  <div className="section">
                    <Row style={{marginBottom: '10px', marginTop: '-5px'}}>
                      <Col sm={12}>
                        <Field
                            name="whereDidYouHearAboutUs"
                            type="text"
                            placeholder={'How did you hear about us?'}
                            component={FieldFormControl}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
            )}
            {channel.key === '' && (
                <div className="section">
                  <Row>
                    <Col sm={4}>
                      <ControlLabel>
                        Age of Vehicle: {this.props.renderDefinition('age_vehicle')}
                      </ControlLabel>
                    </Col>
                    <Col sm={8}>
                      <Field
                          name={'ageVehicle'}
                          placeholder="Vehicle Age"
                          options={vehicleAge}
                          component={SelectControl}
                          clearable={false}
                          validate={[isRequired]}
                      />
                    </Col>
                  </Row>
                </div>
            )}
            {!['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'css-b2c', 'cssr-b2c', 'cspa-b2c', 'cspar-b2c']
                .includes(channel.key) && (
                <div className="section">
                  <Row>
                    <Field
                        name="activities"
                        type="text"
                        component={ActivitiesSelect}
                        onSelectActivity={this.onSelectActivity}
                        renderDefinition={renderDefinition}
                        productActivities={channel.schemes[0].metadata.activities}
                        validate={[
                          isRequired,
                        ]}
                    />
                  </Row>
                </div>
            )}
            <div className="section">
              <Row>
                <MarketingOptions/>
              </Row>
            </div>
            { ['fps-b2c', 'fpr-b2c', 'npo-b2c', 'npor-b2c', 'css-b2c', 'cssr-b2c', 'cspa-b2c', 'cspar-b2c']
                .includes(channel.key) && (
                <div className="section">
                  <Row>
                    <div className="getting-back-quotes-box">
                      <p>
                        We need your consent to use the sensitive details about you in connection with your insurance,
                        Where you have provided us details about other people, we and other insurance market participants
                        also need their consent to use the sensitive details about them in connection with your insurance
                        cover. We need you to make sure you have obtained their consent before you proceed.
                      </p>
                      <Field
                          name="dataConsentChoice"
                          type="checkbox"
                          component={FieldFormControl}
                          validate={[
                            isRequired,
                            isNotFalse,
                          ]}
                      >
                        <div/>
                        Please tick to confirm you have read and understand the above statement and are happy to proceed on
                        this basis.
                      </Field>
                    </div>
                  </Row>
                </div>
            )}
            <div className="aboutUs">
              {this.renderAboutUs()}
            </div>
            <hr/>
            <div className="btn-bar">
              <Button
                  id="continue"
                  bsStyle="primary"
                  className="pull-right btn-remove-border"
                  onClick={this.checkForErrorBeforeSubmit}
                  disabled={submitting || (submitFailed && !valid) || !activitiesValid}
              >
                Continue <FaChevronRight/>
              </Button>
            </div>
          </div>
          {
            this.renderBlockerModal()
          }
        </Form>
    );
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
        values: IPolicyApplication,
        dispatch,
        props: ITripDetailsFormProps,
    ) => {
      if (!previousValues) {
        previousValues = values;
        return;
      }

      let recalculateScore = false;

      if (difference(values.destinations, previousValues.destinations).length > 0) {
        recalculateScore = true;
      }

      if (values.region !== previousValues.region) {
        recalculateScore = true;
      }

      if (recalculateScore) {
        props.actions.quote.recalculateScreening();
      }

      previousValues = values;
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
      (state: IStore) => {
        const tripType = selector(state, 'tripType');
        const groupType = selector(state, 'groupType');
        const startDate = selector(state, 'startDate');
        const endDate = selector(state, 'endDate');
        const destinationsValue = selector(state, 'destinations');
        const occupationValue = selector(state, 'occupations');
        const industryValue = selector(state, 'industries');
        const region = selector(state, 'region');
        const maxTripDuration = selector(state, 'maxTripDuration');
        const residency = selector(state, 'residency');
        const quotationTypes = selector(state, 'quotationTypes');
        const schemeId = selector(state, 'schemeId');
        const cruiseCover = selector(state, 'cruiseCover');
        const travellers = selector(state, 'travellers');
        const salesChannel = selector(state, 'salesChannel');
        const activities = selector(state, 'activities');
        const ageVehicle = selector(state, 'ageVehicle');

        return {
          cruiseCover,
          tripType,
          quotationTypes,
          residency,
          region,
          maxTripDuration,
          groupType,
          startDate,
          schemeId,
          endDate,
          destinationsValue,
          occupationValue,
          industryValue,
          travellers,
          auth: state.auth,
          channel: state.branding.channel,
          salesChannel,
          activities,
          ageVehicle,
          campaignCode: state.quote.campaignCode,
        };
      },
      (dispatch) => ({
        actions: {
          submit: bindActionCreators(submit, dispatch),
          quote: bindActionCreators({...quoteActions}, dispatch),
        },
      }),
  ),
])(TripDetailsForm);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/index.tsx